<template>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md4>
        <v-card class="elevation-12 pi-card">
          <pi-progress v-if="progress"></pi-progress>
          <v-img src="/logo.png" class="pi-card-media" height="80px" :contain="true"></v-img>
          <v-card-text>
            <v-form ref="form" @submit="sendLogin" lazy-validation>
              <v-select
                v-model="project"
                :items="projects"
                item-text="fullName"
                item-value="shortName"
                prepend-icon="developer_board"
                label="System"
                v-if="projects.length > 1"
              ></v-select>
              <v-text-field
                v-model="email"
                :rules="Rules.user.email"
                :disabled="progress"
                required
                prepend-icon="person"
                name="email"
                label="Email"
                type="email"
                @keyup.enter="sendLogin"
              ></v-text-field>
              <v-text-field
                v-model="password"
                :disabled="progress"
                required
                :append-icon="passwordV ? 'visibility' : 'visibility_off'"
                @click:append="() => (passwordV = !passwordV)"
                :type="passwordV ? 'password' : 'text'"
                prepend-icon="lock"
                name="password"
                label="Hasło"
                @keyup.enter="sendLogin"
              ></v-text-field>
              <!-- <v-switch
                :disabled="progress"
                color="primary"
                v-model="remember"
                name="remember"
                label="Zapamiętaj mnie"
              ></v-switch>-->
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn :disabled="progress" flat to="/resetpassword" router>Przypomnij hasło</v-btn>
            <v-btn :disabled="progress" flat color="accent" v-on:click="sendLogin">Zaloguj</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
    <pi-snackbar :color="snackbar.color" :snackbar.sync="snackbar.on" :message="snackbar.message"></pi-snackbar>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    remember: false,
    progress: false,
    email: "",
    password: "",
    passwordV: true,
    snackbar: { on: false, color: "error", message: "" },
    projects: [],
    project: ""
  }),
  computed: {
    isBlocked() {
      return this.progress || this.sended;
    },
    redirectTo() {
      return this.$route.query.redirect || "/";
    },
    hash() {
      return this.$route.params.hash;
    },
    isHashed() {
      return !!this.hash;
    }
  },
  methods: {
    async getProjects() {
      this.projects = this.Auth.avaibleProjects;
      this.project = this.projects.find(p => p.current).shortName;
    },
    async sendLogin() {
      if (!this.$refs.form.validate()) return;
      this.progress = true;
      const response = await this.Auth.login({
        email: this.email,
        password: this.password,
        remember: this.remember
      });
      this.progress = false;
      if (response.status) {
        this.$router.push({ path: this.redirectTo });
        return;
      }
      this.showError(response.message);
    },
    showError(message) {
      this.snackbar.message = message;
      this.snackbar.on = true;
    },
    async loginHash() {
      this.progress = true;
      const response = await this.Auth.loginHash(this.hash);
      this.progress = false;
      if (response.status) {
        this.$router.push({ path: "/" });
        return;
      }
      this.showError(response.message);
    }
  },
  watch: {
    project: function(p) {
      const project = this.projects.find(v => v.shortName === p);
      if (!project || project.current) return;
      window.location.href = `http${project.ssl ? "s" : ""}://${
        project.domain
      }/`;
    }
  },
  async mounted() {
    if (!this.isHashed) return await this.getProjects();
    await this.loginHash();
  }
};
</script>

<style scoped>
.pi-card {
  padding-top: 2rem;
}
.pi-card-media {
  margin: 0 2rem;
}
.pi-progress {
  top: 0;
}
</style>
